import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiService } from "../api.services";
import { superAdminHttpRoutes, superAdminHttpVersion } from "../../../consts/super_admin_http_routes";
import { Banner } from "../../../models/banner.model";

@Injectable({
  providedIn: 'root'
})
export class BannerService {

  private baseUrl: string = superAdminHttpVersion.V1;

  constructor(private apiService: ApiService, private _httpClient: HttpClient) {
  }

  addBanner(banner: any): Observable<any> {
    return this.apiService.httpPostCall(`${this.baseUrl}${superAdminHttpRoutes.BANNER}`, banner);
  }

  filter(q: string, page_number?: number, page_size?: number): Observable<any> {
    let params = new HttpParams()
      .set('q', q);

    if (page_number) {
      params = params.set('page_number', page_number);
    }

    if (page_size) {
      params = params.set('page_size', page_size);
    }

    return this.apiService.httpGetCall(`${this.baseUrl}${superAdminHttpRoutes.BANNER_GET_TABLE}`, params);

  }


  deleteBanner(bannerId: string): Observable<any> {
    return this.apiService.httpDeleteCall(`${this.baseUrl}${superAdminHttpRoutes.BANNER}/${bannerId}`);
  }

  updateBannerPosition(_id: string, order: number) {
    const requestBody = {
      _id: _id,
      order: order
    };

    return this.apiService.httpPatchCall<Banner>(`${this.baseUrl}${superAdminHttpRoutes.MODIFY_BANNER_POSITION}`, requestBody);
  }

  getAllBanners(): Observable<any> {
    return this.apiService.httpGetCallWithoutParameter(`${this.baseUrl}${superAdminHttpRoutes.BANNER}`);
  }

  uploadBanner(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("bucketName", "sos-superadmin-portal");
    formData.append("dirPath", `banners`);

    return this.apiService.httpPostCall<any>(
      `${this.baseUrl}${superAdminHttpRoutes.UPLOAD_PRODUCT_LOGO}`,
      formData
    );
  }
}  